export default "__VITE_ASSET__3899353b__"